import React from 'react';
import { textEllipsis } from '../../../shared/utils/constants';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('mnt_peso_medida.student'),
      field: 'student.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { student } = rowData;
        return (
          <span className="tooltip-test" title={student.fullName}>
            {student.fullName}
          </span>
        );
      },
    },
    { title: t('general.date'), field: 'formattedMeasureDate' },
    { title: t('mnt_peso_medida.height'), field: 'height' },
    { title: t('mnt_peso_medida.weight'), field: 'weight' },
    {
      title: t('general.classes-names'),
      field: 'student.classesNames',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { student } = rowData;
        return (
          <span className="tooltip-test" title={student.classesNames}>
            {student.classesNames}
          </span>
        );
      },
    },
    {
      title: t('general.audit-status'),
      field: 'auditStatus',
    },
  ];
}
